window.Products.HomeDecor.Blanket = function() {};
window.Products.HomeDecor.Blanket.inherits(window.Products.HomeDecor.HomeDecor);
window.Products.HomeDecor.Blanket.id = 117;
window.Products.HomeDecor.Blanket.slug = 'blanket';
window.Products.HomeDecor.Blanket.has_3d = true;
window.Products.HomeDecor.Blanket.use_glb = true;
window.Products.HomeDecor.Blanket.dpi = 150;
window.Products.HomeDecor.Blanket.detailMap = null;

window.Products.HomeDecor.Blanket.prototype.set3dProperties = function(modelViewer) {
	var me = this;

	modelViewer.setFixedView('front');
	
	me.loadEnvMap(function(){
		// Store the map
		me.detailMap = modelViewer.object.children[0].children[0].material.map;
		modelViewer.object.children[0].children[0].material.map = null;

		me.updateThreeTexture(modelViewer);
	});
};

window.Products.HomeDecor.Blanket.prototype.textureCanvasPostpass = function(ctx, modelViewer, scene, texture_resolution){
	if (!this.detailMap) return
	ctx.globalCompositeOperation = "multiply";
	var width = ctx.canvas.width, height = ctx.canvas.height;
	ctx.drawImage(this.detailMap.image,0,0,width/texture_resolution,height/texture_resolution);
};

window.Products.HomeDecor.Blanket.prototype.setThreeControls = function(controls) {
	controls.minDistance = 11;
	controls.maxDistance = 17;
};

window.Products.HomeDecor.Blanket.prototype.updateThreeTexture = function(modelViewer) {
	modelViewer.object.children[0].children[0].material.map = modelViewer.texture;
	//modelViewer.object.children[2].material.map.flipY = false;
	modelViewer.object.children[0].children[0].material.needsUpdate = true;
};